import './index_mWeb.css';
import { convertToDollars, isMobileBrowser } from '../../../utilities/helper';
import useTheme from '../../../utilities/hooks/theme';
import { View, Text } from '../../../component';
import { BottomSheet } from 'react-spring-bottom-sheet';
import Button from '@mui/material/Button/Button';
import I18n from '../../../utilities/locale';
import React from 'react';

const ContestConfirmModalMWeb = ({
  visible,
  onPressDismiss,
  joinContest,
  usableBonusAmount,
  balanceObj,
  totalEntryFee,
  usableBalance
}: any) => {
  const { FantasyTheme: theme } = useTheme();
  const bottomSheetWidth = isMobileBrowser ? 'root_mobile' : 'root';
  const className = `${bottomSheetWidth}`;

  const modalContainerColor = {
    shadowColor: theme.contestConfirmModalContainer,
    backgroundColor: '#192330'
  };

  const borderTopColor = {
    borderTopColor: theme.contestConfirmModalBorder
  };

  const simpleTextColor = {
    color: 'white'
  };

  const buttonColor: any = {
    background: 'linear-gradient(to bottom, #f6c53f, #ffc300)',
    color: theme.contestConfirmModalJoinButtonText,
    width: '50%',
    height: '40px',
    fontSize: '1.3rem',
    textTransform: 'none',
    fontFamily: 'Poppins',
    border: 'solid 1px #fff079',
    fontWeight: 600
  };

  return (
    <BottomSheet className={className} onDismiss={onPressDismiss} open={visible}>
      <View style={modalContainerColor} className={'contest-confirm-modal_mWeb'}>
        <View className={'contest-confirm-modal-row_mWeb '} style={borderTopColor}>
          <Text className={'contest-confirm-modal-simple-text_mWeb'} style={simpleTextColor}>
            {I18n.t('AvailableBalance')}
          </Text>
          <Text
            className={'contest-confirm-modal-simple-text_mWeb'}
            style={simpleTextColor}>{`${convertToDollars(balanceObj['totalBalance'])}`}</Text>
        </View>
        <View className={'contest-confirm-modal-row_mWeb '} style={borderTopColor}>
          <Text className={'contest-confirm-modal-simple-text_mWeb'} style={simpleTextColor}>
            {I18n.t('UsableBonusAmount')}
          </Text>
          <Text
            className={'contest-confirm-modal-simple-text_mWeb'}
            style={simpleTextColor}>{`${convertToDollars(usableBonusAmount)}`}</Text>
        </View>
        <View className={'contest-confirm-modal-row '} style={borderTopColor}>
          <Text className={'contest-confirm-modal-simple-text_mWeb'} style={simpleTextColor}>
            {I18n.t('JoiningAmount')}
          </Text>
          <Text
            className={'contest-confirm-modal-simple-text_mWeb'}
            style={simpleTextColor}>{`${convertToDollars(totalEntryFee)}`}</Text>
        </View>
        <Text className={'contest-confirm-modal-footer-text_mWeb'} style={simpleTextColor}>
          {I18n.t('AcceptAndConfirm')}
        </Text>
        <View className={'contest-confirm-modal-footer_mWeb'}>
          <Button onClick={() => joinContest(totalEntryFee, usableBalance)} style={buttonColor}>
            {'Join Contest'}
          </Button>
        </View>
      </View>
    </BottomSheet>
  );
};
export default React.memo(ContestConfirmModalMWeb);
